/** Homepage — three full-bleed quick-start bands mirroring the mainstream global design brief. */
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Sprout, Flame, Globe2 } from "lucide-react";

const CARDS = [
  {
    Icon: Sprout,
    title: "Build Your Tree",
    blurb: "Document your family, connect generations, and keep your history alive.",
    to: "/family-trees",
    accent: "var(--sepia)",
  },
  {
    Icon: Flame,
    title: "Celebrate a Life",
    blurb: "Honor loved ones with lasting tributes and memorials.",
    to: "/celebrate-a-life",
    accent: "var(--cta)",
  },
  {
    Icon: Globe2,
    title: "Discover Your Heritage",
    blurb: "Explore your roots, cultures and traditions from around the world.",
    to: "/category/heritage",
    accent: "var(--sepia-warm)",
  },
];

const ease = [0.22, 1, 0.36, 1];

export default function QuickStart() {
  return (
    <section data-testid="quick-start-section" className="w-full border-t border-[color:var(--ink-line)]">
      <div className="grid md:grid-cols-3">
        {CARDS.map((c, i) => (
          <motion.div
            key={c.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease }}
            className={i > 0 ? "border-t md:border-t-0 md:border-l border-[color:var(--ink-line)]" : ""}
          >
            <Link
              to={c.to}
              data-testid={`quick-start-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex items-center gap-5 px-6 md:px-10 py-8 md:py-10 h-full hover:bg-[color:var(--parchment-2)] transition-colors duration-300"
            >
              <div
                className="quick-icon-glow w-14 h-14 rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-105"
                style={{ background: c.accent }}
              >
                <c.Icon size={24} className="text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-serif-display text-lg md:text-xl leading-tight">{c.title}</h3>
                <p className="mt-1 text-[13px] leading-snug text-[color:var(--ink-soft)]">{c.blurb}</p>
              </div>
              <ArrowUpRight
                size={18}
                className="shrink-0 text-[color:var(--ink-soft)] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-[color:var(--rust)]"
              />
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
